import { Link } from 'react-router-dom';
import SectionHeading from '@/components/base/SectionHeading';
import { categories } from '@/mocks/categories';

const accentStyles: Record<string, { icon: string; border: string; badge: string }> = {
  primary: {
    icon: 'bg-primary-100 text-primary-600',
    border: 'hover:border-primary-300',
    badge: 'bg-primary-50 text-primary-700',
  },
  accent: {
    icon: 'bg-accent-100 text-accent-700',
    border: 'hover:border-accent-300',
    badge: 'bg-accent-50 text-accent-800',
  },
  secondary: {
    icon: 'bg-secondary-100 text-secondary-700',
    border: 'hover:border-secondary-300',
    badge: 'bg-secondary-50 text-secondary-800',
  },
};

export default function CategorySection() {
  return (
    <section id="categories" className="scroll-mt-24 bg-background-100 py-14 md:py-20">
      <div className="mx-auto max-w-content px-4 md:px-6">
        <SectionHeading
          eyebrow="主题分类"
          title="想找哪种热闹，就从这里进"
          description="站内内容按玩梗场景分成六类，点进去就能看到对应类型的全部现场，省得一条条翻。"
          action={
            <Link
              to="/topics"
              className="inline-flex items-center gap-2 whitespace-nowrap rounded-md bg-foreground-950 px-4 py-2.5 text-sm text-background-50 transition-colors hover:bg-primary-600"
            >
              进入话题分类
              <i className="ri-arrow-right-line" aria-hidden="true" />
            </Link>
          }
        />

        <div className="mt-8 grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
          {categories.map((cat) => {
            const style = accentStyles[cat.accent] ?? accentStyles.primary;
            return (
              <Link
                key={cat.slug}
                to={`/topics?category=${cat.slug}`}
                className={`group flex flex-col rounded-lg border border-background-200 bg-background-50 p-5 transition-colors ${style.border}`}
              >
                <span className="flex items-center justify-between">
                  <span className={`flex h-11 w-11 items-center justify-center rounded-lg text-xl ${style.icon}`}>
                    <i className={cat.icon} aria-hidden="true" />
                  </span>
                  <span className={`rounded-full px-2.5 py-1 text-xs ${style.badge}`}>
                    {cat.count} 篇
                  </span>
                </span>
                <h3 className="mt-4 text-lg text-foreground-950">{cat.name}</h3>
                <p className="mt-2 flex-1 text-sm leading-relaxed text-foreground-600">{cat.desc}</p>
                <span className="mt-4 flex items-center gap-1 text-sm text-primary-600">
                  去看看
                  <i className="ri-arrow-right-line transition-transform group-hover:translate-x-1" aria-hidden="true" />
                </span>
              </Link>
            );
          })}
        </div>
      </div>
    </section>
  );
}